import axios from '../configV2';
const resource = '/callback';

export default {
    async getToken (channel) {
        let url = `${resource}/token`;
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
        return axios.post(url, {channel_name: channel})
    },

    async callUser (cosultationId, patientUserId, channel) {
        let url = `${resource}/call/${cosultationId}/${patientUserId}`;
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
        return axios.post(url, {channel_name: channel})
    },

    async endCall (channel, sendMissedcall = false) {
        let url = `${resource}/call/endcall/${channel}`;
        if (sendMissedcall) {
            url += `?send_missed_call=true`
        }
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
        return axios.post(url, {channel_name: channel})
    },

    async recordCall (channel, action, user_id) {
        let url = `${resource}/call/record/${user_id}/${action}`;
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
        return axios.post(url, {channel_name: channel})
    }
}